import React from "react";
import { useNavigate } from "react-router-dom";
import { Logo, SultanLogo } from "../../assets/icons/Icons";
import { useHospDocData } from "../../lib/contexts/HospitalDoctorContext";

const SULTAN_HOSPITAL_ID = "f6378aa4-0b3c-42e3-be8f-bb8b85f256c0";

// DocTrue brand mark for the top header bar (was previously in the sidebar).
// Honors white-label clinics — Sultan / EasyHeals show their own logo.
// Clicking it navigates to the dashboard, same as the old sidebar logo.
const BrandLogo: React.FC<{
  className?: string;
  /** Width classes for the logo mark. Defaults to the compact navbar size. */
  logoClassName?: string;
}> = ({ className = "", logoClassName = "w-24 lg:w-28" }) => {
  const navigate = useNavigate();
  const { hospitalID, hospData } = useHospDocData();

  return (
    <div
      onClick={() => hospitalID && navigate(`/${hospitalID}/dashboard`)}
      className={`cursor-pointer shrink-0 ${className}`}
    >
      {hospitalID === SULTAN_HOSPITAL_ID ? (
        <SultanLogo style={logoClassName} />
      ) : hospData?.is_easy_heal ? (
        <img
          src={require("../../assets/images/easyHealsLogo.jpg")}
          className={logoClassName}
          alt="EasyHeals"
        />
      ) : (
        <Logo style={logoClassName} />
      )}
    </div>
  );
};

export default BrandLogo;
